import React, { ReactElement, useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/authContext';
import ConfigContext from '../contexts/configContext';
import GetPermissions from '../pages/_layout/_asides/adminfilter';

interface IAdminRouteGuardProps {
	children: ReactElement;
	permissionKey: string;
}

const AdminRouteGuard = ({ children, permissionKey }: IAdminRouteGuardProps) => {
	const { userData, dealerPermissions } = useContext(AuthContext);
	const { publicSettings } = useContext(ConfigContext);

	const isRootUser = useMemo(() => {
		const rootDealerUsername = Array.isArray(publicSettings)
			? (publicSettings as any[]).find((item) => item.key === 'rootDealerUsername')?.value
			: undefined;

		return rootDealerUsername?.toLowerCase() === userData.userName?.toLowerCase();
	}, [publicSettings, userData.userName]);

	const permissions = useMemo(
		() => GetPermissions(dealerPermissions, Boolean(isRootUser)),
		[dealerPermissions, isRootUser],
	);

	if (userData.userTypeId !== 3) {
		return children;
	}

	if (!permissions[permissionKey]) {
		return <Navigate to='/admin' replace />;
	}

	return children;
};

export default AdminRouteGuard;
